<template>
  <div class="ugc-page">
    <div class="ugc-header">
      <h1 class="ugc-title">UGC Sales</h1>
    </div>

    <div class="ugc-stat-card">
      <div class="ugc-stat-icon"><i class="fal fa-coins"></i></div>
      <div class="ugc-stat-body">
        <div class="ugc-stat-value">DKK {{ totalEarned.toFixed(2) }}</div>
        <div class="ugc-stat-label">Total earned</div>
        <div class="ugc-stat-sub">{{ purchases.length }} sale{{ purchases.length === 1 ? '' : 's' }} completed</div>
      </div>
    </div>

    <div class="ugc-main-card">
      <div class="ugc-section-header">
        <div class="ugc-section-header__left">
          <span class="ugc-section-title">Sales</span>
          <span v-if="purchases.length" class="ugc-section-count">{{ purchases.length }}</span>
        </div>
        <div class="ugc-section-header__right">
          <button class="ugc-refresh-btn" :class="{ 'ugc-refresh-btn--loading': loading }" @click="load">
            <i class="fal fa-sync-alt"></i> Refresh
          </button>
        </div>
      </div>

      <div class="ugc-section-body">
        <ugc-sales-data-table :items="purchases" :loading="loading" />
        <p class="ugc-fee-note">Payment fee and platform service fee are not deducted yet.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import UgcSalesDataTable from '../data-tables/UgcSalesDataTable.vue';

export default {
  components: { UgcSalesDataTable },
  data: () => ({ purchases: [], loading: false }),
  computed: {
    totalEarned() {
      return this.purchases
        .filter(p => p.status_label === 'paid')
        .reduce((sum, p) => sum + (p.base_price || 0), 0) / 100;
    },
  },
  created() { this.load(); },
  methods: {
    ...mapActions('influencer', ['getUgcAssetPurchases']),
    async load() {
      this.loading = true;
      try { this.purchases = await this.getUgcAssetPurchases(); }
      finally { this.loading = false; }
    },
  },
};
</script>

<style scoped>
.ugc-page {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: 24px 20px 40px;
}
.ugc-header { margin-bottom: 20px; }
.ugc-title { font-size: 22px; font-weight: 650; color: var(--ink); margin: 0; letter-spacing: -.02em; }

.ugc-stat-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--surface, #fff);
  border: 1px solid var(--line, #eaecf0);
  border-radius: var(--r-lg, 14px);
  padding: 20px;
  margin-bottom: 16px;
  max-width: 320px;
}
.ugc-stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(29,184,122,0.1);
  color: #1db87a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}
.ugc-stat-value { font-size: 20px; font-weight: 700; color: var(--ink-1, #111); line-height: 1.2; }
.ugc-stat-label { font-size: 11.5px; font-weight: 600; color: var(--ink-3, #aaa); text-transform: uppercase; letter-spacing: .03em; margin-top: 2px; }
.ugc-stat-sub { font-size: 11.5px; color: var(--ink-3, #aaa); margin-top: 4px; }

.ugc-main-card {
  background: var(--surface, #fff);
  border: 1px solid var(--line, #eaecf0);
  border-radius: var(--r-lg, 14px);
}

.ugc-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--line, #eaecf0);
}
.ugc-section-header__left { display: flex; align-items: center; gap: 8px; }
.ugc-section-title { font-size: 14px; font-weight: 600; color: var(--ink-1, #111); }
.ugc-section-count {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 20px; height: 20px; padding: 0 6px; border-radius: 999px;
  background: var(--surface-2, #f3f3f3); color: var(--ink-2, #555);
  font-size: 11px; font-weight: 700;
}

.ugc-refresh-btn {
  display: flex; align-items: center; gap: 6px;
  height: 32px; padding: 0 12px;
  border: 1px solid var(--line, #e0e0e0); border-radius: var(--r-ctrl, 8px);
  background: transparent; color: var(--ink-2, #555);
  font-size: 12.5px; font-weight: 600; cursor: pointer;
}
.ugc-refresh-btn:hover { background: var(--surface-2, #f7f7f7); }
.ugc-refresh-btn--loading i { animation: ugc-spin 1s linear infinite; }
@keyframes ugc-spin { to { transform: rotate(360deg); } }

.ugc-section-body { padding: 20px; }

.ugc-fee-note {
  margin: 14px 0 0;
  font-size: 11.5px;
  font-style: italic;
  color: var(--ink-3, #aaa);
}
</style>